/* import __COLOCATED_TEMPLATE__ from './recent-conversation.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-experience */
import Component from '@glimmer/component';
import type Conversation from 'embercom/objects/inbox/conversation';
import type ConversationTableEntry from 'embercom/objects/inbox/conversation-table-entry';
import type LatestConversationSummary from 'embercom/objects/inbox/latest-conversation-summary';

interface Args {
  conversation: LatestConversationSummary | ConversationTableEntry;
  currentConversation: Conversation;
  selectedConversation: LatestConversationSummary;
  onClose: () => void;
}

export default class RecentConversation extends Component<Args> {
  get user() {
    if ('firstParticipant' in this.args.conversation) {
      return this.args.conversation.firstParticipant;
    } else {
      return this.args.currentConversation.firstParticipant;
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::CommandK::MergeInto::RecentConversation': typeof RecentConversation;
    'inbox2/command-k/merge-into/recent-conversation': typeof RecentConversation;
  }
}
